<template>
    <HomeContentLayout>
            <span>这是主控台</span>
    </HomeContentLayout>
</template>

<script>
    export default {
        name: "Main"
    }
</script>

<style scoped>

</style>
